import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';
import { normalizeFileName } from '../../../components/ui/utils/fileNameEncoding';
import SplitViewFieldsGrid from '../../../components/generic/SplitViewFieldsGrid';
import { badgeClass, getBadgeStyleTokens } from '../../../config/tableBadgeStyles';

const manualFieldOverride = (field, record, theme) => {
  const rawVal = record[field.name];
  const isEmpty = rawVal == null || rawVal === '';

  if (field.name === 'manualTypeId') {
    const displayVal =
      record.manualTypeName ||
      record.manualType?.typeName ||
      (rawVal != null ? `#${rawVal}` : '—');
    return <span className={theme.text.primary}>{displayVal}</span>;
  }

  if (field.type === 'multiSelect' && field.name === 'departmentIds') {
    const arr = record.manualDepartments || rawVal;
    const displayVal = Array.isArray(arr)
      ? arr
          .map((d) => (typeof d === 'object' ? d.name : d))
          .filter(Boolean)
          .join(', ') || '—'
      : '—';
    return <span className={theme.text.primary}>{displayVal}</span>;
  }

  if (field.name === 'status') {
    const displayVal = record.statusLabel || rawVal;
    return (
      <span className={badgeClass(getBadgeStyleTokens().blue, theme)}>
        {String(displayVal ?? '—')}
      </span>
    );
  }

  if (field.type === 'fileUpload') {
    return null;
  }

  return undefined;
};

const ManualDetailsTab = ({ selectedRecord, selectedRecordFiles, config, fields }) => {
  const { theme } = useTheme();

  return (
    <div
      className="p-4 flex-1 overflow-y-auto advanced-table-scroll"
      style={{ scrollbarWidth: 'thin', minHeight: 0, maxHeight: '100%' }}
    >
      <div className="grid grid-cols-1 gap-4">
        <SplitViewFieldsGrid
          selectedRecord={selectedRecord}
          fields={fields}
          config={config}
          layout="boxed"
          skipTypes={['hidden', 'fileUpload']}
          fieldOverride={manualFieldOverride}
        />

        {config.features?.fileAttachments && selectedRecordFiles?.length > 0 && (
          <div>
            <div className={cn('text-sm font-semibold mb-2', theme.text.primary)}>Attachments</div>
            <ul className="space-y-1 text-sm">
              {selectedRecordFiles.map((file) => (
                <li key={file.id}>{normalizeFileName(file.fileName)}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ManualDetailsTab;
